import { Component, OnInit } from '@angular/core';
import { AgentReferenceHandlerComponent } from './agent-reference.handler';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-reference',
  templateUrl: './agent-reference.component.html',
  styleUrls: ['./agent-reference.component.scss'],
})
export class AgentReferenceComponent extends AgentReferenceHandlerComponent {
  constructor(agentService: AgentService) {
    super(agentService);
  }
}
